import { Link } from "react-router-dom";
import { DOCTOR } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="bg-navy-600 text-beige-100 mt-32" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="text-[10px] uppercase tracking-[0.28em] text-brass-400 mb-4">
            Dr. Vikas Matai
          </div>
          <div className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight">
            Contact for a genuine opinion.
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.28em] text-brass-400 mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm text-beige-100/80">
            <li>{DOCTOR.phoneDisplay}</li>
            <li>{DOCTOR.city}</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.28em] text-brass-400 mb-4">
            Directory
          </div>
          <ul className="space-y-3 text-sm">
            <li className="group relative" data-testid="footer-locations">
              <span className="link-underline inline-flex items-center gap-1 cursor-default text-beige-100">
                Locations
                <span className="text-brass-400 transition-transform duration-300 group-hover:rotate-90">›</span>
              </span>
              <ul className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] group-focus-within:grid-rows-[1fr] transition-[grid-template-rows] duration-300 ease-out">
                <li className="overflow-hidden">
                  <div className="pt-3 pl-4 space-y-2 border-l border-beige-100/20 mt-2">
                    <a
                      className="link-underline block text-beige-100/80 hover:text-beige-100"
                      href="https://www.google.com/maps/search/?api=1&query=Sadguru+Clinic+Akota+Vadodara"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="footer-location-a"
                    >
                      (A) Sadguru Clinic, Akota ↗
                    </a>
                    <a
                      className="link-underline block text-beige-100/80 hover:text-beige-100"
                      href="https://www.google.com/maps/search/?api=1&query=Welcare+Hospital+Atladra+Vadodara"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="footer-location-b"
                    >
                      (B) Welcare Hospital, Atladra ↗
                    </a>
                  </div>
                </li>
              </ul>
            </li>
            <li><Link className="link-underline" to="/conditions">Conditions</Link></li>
            <li><Link className="link-underline" to="/book">Book Appointment</Link></li>
            <li>
              <a
                className="link-underline"
                href={DOCTOR.googleReviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-reviews"
              >
                See our awesome reviews ↗
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-beige-100/10">
        <div className="mx-auto max-w-[1600px] px-6 lg:px-12 py-6">
          <div className="text-[10px] uppercase tracking-[0.28em] text-beige-100/50">
            © {new Date().getFullYear()} Dr. Vikas Matai · All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
